// src/services/eventService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getEvents = async () => {
  return await axios.get(`${API_URL}/events`);
};


const getEventDetail = async () => {
  return await axios?.get(`${API_URL}/event_departments/details`);
};

const getEvent = async (id) => {
  return await axios.get(`${API_URL}/events/${id}`);
};

const createEvent = async (eventData) => {
  return await axios.post(`${API_URL}/events/`, eventData);
};

const updateEvent = async (id, eventData) => {
  return await axios.put(`${API_URL}/events/${id}`, eventData);
};

const deleteEvent = async (id) => {
  return await axios.delete(`${API_URL}/events/${id}`);
};

const assignDepartments = async (data) => {
  return await axios.post(`${API_URL}/event_departments/`, data);
};

const removeDepartmentAssignment = async (id) => {
  return await axios.delete(`${API_URL}/event_departments/${id}`);
};

const getEventsDepartments = async () => {
  return await axios.get(`${API_URL}/event_departments/`);
};

const getEventsDepartmentsById = async (id) => {
  return await axios.get(`${API_URL}/event_departments/${id}`);
};

export default {
  getEvents,
  getEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  assignDepartments,
  getEventsDepartments,
  getEventsDepartmentsById,
  removeDepartmentAssignment,
  getEventDetail,
};
